var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{attrs:{"width":"800","height":"250"}}),_vm._v(" "),(_vm.period)?_c('PublicationBreakdownModal',{attrs:{"period":_vm.period,"portal":_vm.portal,"user":_vm.user,"granularity":_vm.granularity,"selected-channel":_vm.selectedChannel}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }